"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: var(--font-size-defult);\n  color: var(--color-secondary);\n\n  display: inline-block;\n  padding: 0 1rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 1.5rem 0.5rem 0 0.5rem;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/styles");

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var styled_components_1 = __importDefault(require("styled-components"));

exports.StyledButton = styles_1.styled(Button_1.default)({
  fontSize: 'var(--font-size-medium)',
  padding: '.75rem 1rem',
  fontWeight: 'bold',
  boxShadow: "var(--box-shadow-default)"
});
exports.ButtonBoxDiv = styled_components_1.default.div(_templateObject());
exports.ErrorMessageSpan = styled_components_1.default.span(_templateObject2());